import React from "react";
import {
  ArrayInput,
  Button,
  NumberInput,
  required,
  ResourceContextProvider,
  SimpleFormIterator,
  TextInput,
  useNotify,
} from "react-admin";
import AddIcon from "@mui/icons-material/Add";
import FormModal from "server/components/Modals/FormModal";
import dataProvider from "server/dataProvider";
import { studentRequests } from "api/studentApi";

const AddMidSemesterGradesDialog = ({ studentEducationId, disciplineId, fetchMidSemesterGrades }) => {
  const notify = useNotify();

  const handleConfirm = async values => {
    const items = values.items ?? [];
    if (!items.length) {
      notify("Моля добавете поне една оценка!", { type: "error" });
      return false;
    }
    const payload = {
      items: items.map(({ grade, comment }) => ({
        grade: Number(grade),
        comment: comment?.trim() || null,
      })),
    };
    await dataProvider.customRequest(
      studentRequests.createMidSemesterGrades(studentEducationId, disciplineId),
      payload,
      "POST",
    );
    notify("Успешно добавихте междинни семестриални оценки", { type: "success" });
    fetchMidSemesterGrades();
  };

  return (
    <FormModal
      titleContent="Добави междинни оценки"
      dialogSize="md"
      onConfirm={handleConfirm}
      defaultValues={{ items: [{ grade: null, comment: "" }] }}
      triggerButton={
        <Button
          label="Добави оценка"
          startIcon={<AddIcon />}
          variant="contained"
          size="small"
        />
      }
    >
      <ResourceContextProvider value="midSemesterGrades">
        <ArrayInput
          source="items"
          label=""
        >
          <SimpleFormIterator
            inline
            disableReordering
          >
            <NumberInput
              source="grade"
              label="Оценка"
              min={2}
              max={6}
              step={0.01}
              validate={required()}
            />
            <TextInput
              source="comment"
              label="Описание"
            />
          </SimpleFormIterator>
        </ArrayInput>
      </ResourceContextProvider>
    </FormModal>
  );
};

export default AddMidSemesterGradesDialog;
